import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { getMeetingTitleByMeeting } from 'app/utils/appHelpers';
import VideoLinkCard from '../Card/VideoLinkCard';

function VideoLinkDialog({ open, onClose, meeting, setVideoLinkDialogStatus }) {

  return (
    <Dialog onClose={onClose} open={open} maxWidth={'lg'} fullWidth>
      <DialogTitle> {getMeetingTitleByMeeting(meeting)}</DialogTitle>
      <DialogContent>
        <VideoLinkCard meeting={meeting} setVideoLinkDialogStatus={setVideoLinkDialogStatus} />
      </DialogContent>

    </Dialog>
  );
}


export default VideoLinkDialog